import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const TotalProductionIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M19.2856 9.35011C18.8326 9.54017 18.36 10.0027 17.9182 10.6883C17.3352 11.5931 17.1337 12.7333 17.4475 13.874H25.8547C26.0447 12.9954 25.8959 12.3244 25.699 11.8728C25.3297 11.0257 24.569 10.3785 23.433 9.94167C23.8923 9.29345 24.5273 9.17813 25.2686 9.37174C25.6609 9.47404 26.0574 9.22144 26.1544 8.80722C26.2514 8.393 26.0121 7.9742 25.6199 7.8717C24.3068 7.52881 23.0699 7.87128 22.2581 9.02021C21.8089 8.52671 21.1394 8.43024 20.5988 8.6989C19.229 9.37983 19.3107 9.34012 19.2856 9.35011Z" fill="#1C1F28" />;
    t1 = <path d="M11.2942 7.92404C12.0218 8.23617 12.6997 8.87332 13.3088 9.81899C14.1021 11.0503 14.3495 12.5343 14.0759 13.8742H15.9418C15.6691 12.5382 15.9135 11.0536 16.709 9.81899C17.3181 8.87332 17.996 8.23617 18.7236 7.92404L19.3013 7.63678C17.0109 4.96448 13.009 4.96191 10.7166 7.63678L11.2942 7.92404Z" fill="#1C1F28" />;
    t2 = <path d="M2.52319 16.1906V19.6931C2.52319 20.1198 2.85072 20.4657 3.25472 20.4657H26.7613C27.1653 20.4657 27.4928 20.1198 27.4928 19.6931V16.1906C27.4928 15.7639 27.1653 15.418 26.7613 15.418H3.25472C2.85072 15.418 2.52319 15.7639 2.52319 16.1906ZM6.63733 18.681C6.2659 18.7975 5.85576 18.5991 5.72486 18.1659C5.61718 17.7922 5.78836 17.3486 6.21206 17.2027C6.62494 17.0728 7.0524 17.3368 7.14208 17.791C7.20846 18.1655 7.02343 18.5477 6.63733 18.681ZM23.663 18.7108C23.2598 18.7554 22.8958 18.4295 22.8637 18.0181C22.8267 17.6369 23.0653 17.2681 23.4484 17.1842C23.8858 17.0972 24.2755 17.419 24.3194 17.8656C24.3594 18.277 24.0762 18.6665 23.663 18.7108Z" fill="#1C1F28" />;
    t3 = <path d="M4.13269 24.5363C4.13269 24.963 4.46022 25.3089 4.86422 25.3089H25.152C25.556 25.3089 25.8836 24.963 25.8836 24.5363V22.0125H4.13269V24.5363Z" fill="#1C1F28" />;
    t4 = <path d="M12.5679 13.8746C12.8816 12.7341 12.6804 11.5939 12.0973 10.6889C11.6554 10.0033 11.1829 9.54078 10.7298 9.35072C10.7022 9.3397 9.65377 8.81742 9.6587 8.81989C8.95121 8.4682 8.07249 8.62092 7.5178 9.29891C7.21914 8.77322 7.32409 8.05619 7.5077 7.47452C7.63547 7.06972 7.42831 6.63217 7.04503 6.49722C6.66156 6.36237 6.24747 6.58107 6.11969 6.98587C5.64976 8.47484 5.91867 9.4782 6.25459 10.0789C4.66424 10.7962 3.77587 12.0947 4.16075 13.8746H12.5679Z" fill="#1C1F28" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props) {
    t5 = <svg {...props} viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}{t3}{t4}</svg>;
    $[5] = props;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};